import React from "react";

import { withTranslation, WithTranslation } from "react-i18next";
import AuthService from "../../../../../common/AuthService";
import { IMessageBoxParams } from "../../../../../common/MessageBox";
import { IConfirmDialogParams } from "../../../../../common/ConfirmDialog";
import { IProjectRow } from "../../../../../webapi/service/getProjects";

import "../../../../main.css";
import { t } from "i18next";
import FkdppSimulationContents from "./FkdppSimulationContents";

export interface IProps extends WithTranslation {
  /**
   * 認証サービス
   */
  authService?: AuthService;
  /**
   * 選択されたプロジェクト情報
   */
  projectInfo: IProjectRow;
  /**
   * 戻るボタンが押された場合に呼び出されます
   */
  onBack: () => void;
  /**
   * プロジェクト一覧画面に戻る場合に呼び出します
   */
  onTop: () => void;
  /**
   * ファイル一覧をロードする場合に呼び出します
   * @param loading - ローディング画面を表示する場合はtrue
   */
  onLoadFiles: (loading: boolean) => void;
  /**
   * ローディング画面の表示非表示を切り替えます
   * @param loading - ローディング画面を表示する場合はtrue
   */
  onLoading: (loading: boolean) => void;
  /**
   * メッセージBoxを表示します
   * @param params - メッセージBoxパラメータ
   */
  showMessage: (params: IMessageBoxParams) => void;
  /**
   * 確認ダイアログを表示します。
   * @param params - 確認ダイアログパラメータ
   */
  showConfirm: (param: IConfirmDialogParams) => void;
  /**
   * 通信エラーが発生した場合に呼び出します
   * @param id - メッセージID
   * @param status - httpステータスコード
   */
  onCommunicationError: (
    id: string | undefined,
    status: number | undefined
  ) => void;
  /**
   * 非操作タイムアウトをリセットする場合に呼び出します
   */
  resetUnoperatedTimeout: () => void;
}

class FkdppSimulation extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  getContents(): JSX.Element {
    const {
      authService,
      projectInfo,
      onBack,
      onTop,
      onLoadFiles,
      onLoading,
      showMessage,
      showConfirm,
      onCommunicationError,
      resetUnoperatedTimeout,
    } = this.props;
    let contents = <div />;
    contents = (
      <div className="mainspace">
        <div className="mainspace-title">
          <h3>{t("project_detail_project_name")}</h3>
          <h3 style={{ marginLeft: "10px" }}>{projectInfo.name}</h3>
        </div>
        <FkdppSimulationContents
          authService={authService}
          projectInfo={projectInfo}
          onBack={onBack}
          onTop={onTop}
          onLoadFiles={onLoadFiles}
          onLoading={onLoading}
          showMessage={showMessage}
          showConfirm={showConfirm}
          onCommunicationError={onCommunicationError}
          resetUnoperatedTimeout={resetUnoperatedTimeout}
        />
      </div>
    );
    return contents;
  }

  render(): JSX.Element {
    const contents = this.getContents();
    return contents;
  }
}

export default withTranslation()(FkdppSimulation);
